import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CommonMessages } from '@app/constants/common.messages';
import { GoalsMessages } from '@app/goals/goals.messages';
import { Site } from '@app/models/site.model';
import { CompanyAPIService } from '@app/shared/api/company/company.api.service';
import { Globals } from '@app/shared/globals/globals';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonGoalCreateFormPart } from '../../goal-create-views/goal-create-main/goal-create-main.component';
import { TerminologyEntity } from '@app/domain/terminology/model/terminology-entity.enum';

@Component({
  selector: 'app-goal-create-part-site',
  templateUrl: './goal-create-part-site.component.html',
  styleUrls: ['./goal-create-part-site.component.scss']
})
export class GoalCreatePartSiteComponent implements OnInit, OnDestroy, CommonGoalCreateFormPart {

  public readonly eTerminologyEntity = TerminologyEntity;
  public readonly eCommonMessages = CommonMessages;
  public readonly eGoalsMessages = GoalsMessages;

  private readonly ngUnsubscribe$ = new Subject<void>();

  @Input() controlSite: UntypedFormControl;
  @Input() submitted: boolean;
  @Input() submittedDraft: boolean;
  @Input() parentDropdownOpen: boolean;

  @Output() onSetParentDropdown: EventEmitter<boolean>;

  possibleSites: Site[];

  searchControl: UntypedFormControl;

  get possibleSitesDisplay(): Site[] {
    return this.possibleSites
      .filter(d => {
        if ((d.id !== this.controlSite.value) && (!this.parentDropdownOpen)) {
          return false;
        }

        const searchArgument = this.searchControl.value.trim().toLocaleLowerCase();

        if (!searchArgument) {
          return true;
        }

        if (searchArgument.length === 0) {
          return true;
        }

        if(d.name.trim().toLocaleLowerCase().includes(searchArgument)) {
          return true;
        }

        return false;
      });
  }

  constructor(
    public globals: Globals,
    private companyAPIService: CompanyAPIService
  ) {
    this.controlSite = new UntypedFormControl(null, []);
    this.possibleSites = [];
    this.submitted = false;
    this.submittedDraft = false;
    this.parentDropdownOpen = true;
    this.searchControl = new UntypedFormControl('', []);
    this.onSetParentDropdown = new EventEmitter<boolean>();
  }

  ngOnInit(): void {
    this.getPossibleSiteChoices();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.unsubscribe();
  }

  getPossibleSiteChoices(): void {
    this.companyAPIService.getAllSites()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(
        (sites) => {
          this.possibleSites = sites;
        }
      );
  }

  onSelectSite(site: Site): void {
    if (this.controlSite.value !== site) {
      this.controlSite.setValue(site.id);
    }

    if (!this.parentDropdownOpen) {
      this.controlSite.setValue(null);
      this.setParentDropdown(true);
    }
  }

  setParentDropdown(expanded: boolean): void {
    this.onSetParentDropdown.emit(expanded);
  }

  focus(): void {
    // TODO:
  }
}
